import { reactive } from 'vue';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
}

const toasts = reactive<Toast[]>([]);
let nextId = 1;

export function useToast() {
  // Design system: confirmations go after 5 s; errors stay until dismissed; at most three stacked.
  const push = (kind: Toast['kind'], message: string) => {
    const id = nextId++;
    toasts.push({ id, kind, message });
    while (toasts.length > 3) toasts.shift();
    if (kind !== 'error') setTimeout(() => dismiss(id), 5000);
  };
  const dismiss = (id: number) => {
    const index = toasts.findIndex((t) => t.id === id);
    if (index >= 0) toasts.splice(index, 1);
  };
  return {
    toasts,
    dismiss,
    success: (m: string) => push('success', m),
    error: (m: string) => push('error', m),
    info: (m: string) => push('info', m),
  };
}
